// Cart Bug Fix v1.15
// Fix 1: onCartUpdate — correct section IDs and DOM selectors
// Fix 2: removeUpsellProduct — correct Accept header + native fetch
// Fix 3: Key-based cart item deletion using native fetch
// Fix 4: Auto-remove upsell when last master product is deleted
// v1.13: loose quantity check (handles string "0"), verbose logging
// v1.15: pass items array (not item_count) to updateCartUpsellVisibility for per-product eligibility check
// v1.15: patch updateCartUpsellVisibility itself — uses _easel_upsell line-item property; handles legacy
//         number call from connectedCallback with async re-check

(function () {
  'use strict';

  var _nativeFetch = window.__cartNativeFetch || window.fetch.bind(window);

  function getItemKeyForLine(lineNum) {
    var buttons = document.querySelectorAll('cart-remove-button[data-index="' + lineNum + '"]');
    console.log('[CartFix] v1.15 getItemKeyForLine(' + lineNum + '): found ' + buttons.length + ' buttons');
    // Pass 1: data-key attribute
    for (var i = 0; i < buttons.length; i++) {
      var k = buttons[i].dataset && buttons[i].dataset.key;
      console.log('[CartFix] v1.15   button[' + i + '] data-key=' + (k || '(none)'));
      if (k) return k;
    }
    // Pass 2: parse from <a href>
    for (var j = 0; j < buttons.length; j++) {
      var anchor = buttons[j].querySelector('a[href]');
      if (anchor && anchor.href && anchor.href.indexOf('cart/change') !== -1) {
        try {
          var url = new URL(anchor.href, window.location.origin);
          var id = url.searchParams.get('id');
          if (id) return id;
        } catch (e) {}
      }
    }
    return null;
  }

  function applyCartFix(CartItemsClass) {
    var _origUpdateQuantity = CartItemsClass.prototype.updateQuantity;

    CartItemsClass.prototype.updateQuantity = function (line, quantity, name, variantId) {
      console.log('[CartFix] v1.15 updateQuantity called: line=' + line + ', quantity=' + JSON.stringify(quantity) + ', type=' + typeof quantity);

      // Use loose equality so both number 0 and string "0" are treated as delete
      if (quantity != 0) {
        console.log('[CartFix] v1.15 quantity != 0, delegating to original');
        return _origUpdateQuantity.apply(this, arguments);
      }

      var lineNum = parseInt(line, 10);
      var itemKey = getItemKeyForLine(lineNum);
      if (!itemKey) {
        console.warn('[CartFix] v1.15: No key for line ' + lineNum + ' — using original');
        return _origUpdateQuantity.apply(this, arguments);
      }

      var self = this;
      console.log('[CartFix] v1.15 native-fetch delete: line ' + lineNum + ' → key ' + itemKey);
      self.enableLoading(line);

      var payload = { id: itemKey, quantity: 0, sections_url: window.location.pathname };
      var hasSections = false;
      try {
        payload.sections = self.getSectionsToRender().map(function (s) { return s.section; });
        hasSections = true;
      } catch (e) {}

      _nativeFetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (response) { return response.text(); })
        .then(function (responseText) {
          var parsedState = JSON.parse(responseText);
          console.log('[CartFix] v1.15 cart/change response: item_count=' + parsedState.item_count + ', items=' + (Array.isArray(parsedState.items) ? parsedState.items.length : 'n/a') + ', errors=' + !!parsedState.errors);

          if (parsedState.errors) {
            console.warn('[CartFix] v1.15 cart/change returned errors:', parsedState.errors);
            var quantityEl = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
            if (quantityEl) quantityEl.value = quantityEl.getAttribute('value');
            self.updateLiveRegions(line, parsedState.errors);
            return;
          }

          self.classList.toggle('is-empty', parsedState.item_count === 0);
          var cartDrawerWrapper = document.querySelector('cart-drawer');
          var cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          if (hasSections && parsedState.sections) {
            try {
              self.getSectionsToRender().forEach(function (section) {
                var container = document.getElementById(section.id);
                if (!container) return;
                var target = container.querySelector(section.selector) || container;
                if (target && parsedState.sections[section.section]) {
                  target.innerHTML = self.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }
              });
            } catch (renderErr) { self.onCartUpdate(); }
          } else { self.onCartUpdate(); }

          self.updateLiveRegions(line, '');

          if (typeof trapFocus === 'function') {
            if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
            }
          }

          if (typeof self.updateProgressBar === 'function') {
            self.updateProgressBar({ total_price: parsedState.total_price, items_subtotal_price: parsedState.items_subtotal_price });
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
          }

          // ── Fix 4: Property-based upsell detection ───────────────────────
          if (Array.isArray(parsedState.items) && parsedState.items.length > 0) {
            var remainingNonUpsell = parsedState.items.filter(function (item) {
              var isUpsell = item.properties &&
                item.properties._upsell === 'true' &&
                item.properties._upsell_type === 'cart_checkbox';
              return !isUpsell;
            });
            console.log('[CartFix] v1.15 Fix4: remaining items=' + parsedState.items.length + ', non-upsell=' + remainingNonUpsell.length);
            if (parsedState.items.length > 0) {
              parsedState.items.forEach(function(item, idx) {
                console.log('[CartFix] v1.15 Fix4 item[' + idx + ']:', item.title, 'props:', JSON.stringify(item.properties));
              });
            }
            if (remainingNonUpsell.length === 0 && typeof self.removeUpsellProduct === 'function') {
              var upsellTag = document.querySelector('script[data-cart-upsell-variant-id]');
              var upsellVarId = upsellTag ? upsellTag.dataset.cartUpsellVariantId : parsedState.items[0].variant_id.toString();
              console.log('[CartFix] v1.15: Only upsell items remain — auto-removing (variantId=' + upsellVarId + ')');
              self.removeUpsellProduct(upsellVarId);
              return;
            }
          } else {
            console.log('[CartFix] v1.15 Fix4: skipped — items array empty or missing (item_count=' + parsedState.item_count + ')');
          }
          // ── End Fix 4 ─────────────────────────────────────────────

          if (typeof self.updateCartUpsellToggleState === 'function') {
            self.updateCartUpsellToggleState().catch(function (e) { console.error(e); });
          }
          // v1.15: pass items array so visibility check can inspect per-product eligibility
          if (typeof self.updateCartUpsellVisibility === 'function') {
            self.updateCartUpsellVisibility(parsedState.items);
          }
        })
        .catch(function (err) {
          console.error('[CartFix] cart/change error:', err);
          self.querySelectorAll('.loading__spinner').forEach(function (overlay) { overlay.classList.add('hidden'); });
          var errEl = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errEl) errEl.textContent = (window.cartStrings && window.cartStrings.error) || 'Error';
        })
        .finally(function () { self.disableLoading(line); });
    };

    CartItemsClass.prototype.onCartUpdate = async function () {
      try {
        var updates = [];
        var hasDrawer = document.querySelector('cart-drawer-items') || document.querySelector('.cart-drawer__footer');
        if (hasDrawer) {
          updates.push((async () => {
            var response = await _nativeFetch(routes.cart_url + '?section_id=cart-drawer');
            var responseText = await response.text();
            var html = new DOMParser().parseFromString(responseText, 'text/html');
            ['cart-drawer-items', '.drawer__footer'].forEach(function (selector) {
              var targetEl = document.querySelector(selector);
              var sourceEl = html.querySelector(selector);
              if (targetEl && sourceEl) targetEl.replaceWith(sourceEl);
            });
          })());
        }
        var mainCartRoot = document.getElementById('main-cart-items');
        if (mainCartRoot) {
          updates.push((async () => {
            var sectionId = mainCartRoot.dataset.id;
            var response = await _nativeFetch(routes.cart_url + '?section_id=' + sectionId);
            var responseText = await response.text();
            var html = new DOMParser().parseFromString(responseText, 'text/html');
            var sourceContents = html.querySelector('.js-contents');
            if (sourceContents) mainCartRoot.querySelector('.js-contents').innerHTML = sourceContents.innerHTML;
          })());
        }
        await Promise.all(updates);
        await this.updateCartUpsellToggleState();
        try {
          var cartResp = await _nativeFetch(routes.cart_url + '.js');
          var parsed = await cartResp.json();
          // v1.15: pass items array for per-product eligibility check
          this.updateCartUpsellVisibility(parsed.items);
        } catch (e) {}
      } catch (e) { console.error('[CartFix] onCartUpdate error:', e); throw e; }
    };

    CartItemsClass.prototype.removeUpsellProduct = async function (cartUpsellVariantId) {
      try {
        var cartResp = await _nativeFetch(routes.cart_url + '.js');
        var cart = await cartResp.json();
        var upsellItem = cart.items.find(function (item) {
          if (item.variant_id.toString() === cartUpsellVariantId.toString()) {
            if (item.properties && item.properties._upsell === 'true' && item.properties._upsell_type === 'cart_checkbox') return true;
            if (!item.properties || !item.properties._upsell) return true;
          }
          return false;
        });
        if (!upsellItem) { console.log('[CartFix] Upsell item not found or already removed'); this.removingUpsellProduct = false; return; }
        console.log('[CartFix] v1.15 removeUpsellProduct: removing key=' + upsellItem.key);
        var response = await _nativeFetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: upsellItem.key, quantity: 0 })
        });
        if (!response.ok) throw new Error('[CartFix] Failed to remove upsell product');
        await this.onCartUpdate();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        this.removingUpsellProduct = false;
      } catch (error) { console.error('[CartFix] removeUpsellProduct error:', error); this.removingUpsellProduct = false; }
    };

    // ── Fix 5: Patch updateCartUpsellVisibility for per-product eligibility ─────────
    // The original function (cart.js) only checks itemCount > 0.
    // We replace it to inspect the _easel_upsell line-item property on each item.
    // Also handles the legacy number call from connectedCallback via async re-fetch.
    CartItemsClass.prototype.updateCartUpsellVisibility = function (itemsOrCount) {
      var cartUpsellContainer = document.querySelector('.cart-upsell-toggle-container');
      if (!cartUpsellContainer) return;

      var hasEligibleItem = false;

      if (Array.isArray(itemsOrCount)) {
        // Called by patched updateQuantity / onCartUpdate with full items array
        hasEligibleItem = itemsOrCount.some(function (item) {
          return item.properties && item.properties._easel_upsell === 'true';
        });
        console.log('[CartFix] v1.15 updateCartUpsellVisibility: items=' + itemsOrCount.length + ', eligible=' + hasEligibleItem);
      } else {
        // Called from connectedCallback with item_count (a number).
        // Hide initially, then async-fetch the items array and re-evaluate.
        console.log('[CartFix] v1.15 updateCartUpsellVisibility: legacy number call (' + itemsOrCount + '), scheduling async re-check');
        if (typeof itemsOrCount === 'number' && itemsOrCount > 0) {
          var self = this;
          _nativeFetch(routes.cart_url + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { self.updateCartUpsellVisibility(cart.items); })
            .catch(function (e) { console.error('[CartFix] v1.15 async re-check error:', e); });
        }
        // hasEligibleItem stays false → container hidden until async result arrives
      }

      if (hasEligibleItem) {
        cartUpsellContainer.classList.remove('hidden');
      } else {
        cartUpsellContainer.classList.add('hidden');
      }
    };
    // ── End Fix 5 ─────────────────────────────────────────────────────────────────

    console.log('[CartFix] v1.15 patches applied (native fetch: ' + (window.__cartNativeFetch ? 'YES' : 'NO') + ')');
  }

  if (typeof customElements !== 'undefined') {
    customElements.whenDefined('cart-items').then(function () {
      var CartItemsClass = customElements.get('cart-items');
      if (CartItemsClass) applyCartFix(CartItemsClass);
    });
  }
})();